import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

/** The same ProMaster mark is used throughout loading. */
const PROMASTER_MARK = "/favicon-192.png";

interface ScreenProps {
    /** covers the whole viewport, for the first paint and the hand-over to sign-in */
    fullscreen?: boolean;
    /** read by a screen reader only: the page shows no words */
    label?: string;
    className?: string;
}

/** Removes the copy of the waiting page that index.html draws before the
 *  bundle runs, once React has painted its own tree. */
export function BootSplashCleanup() {
    useLayoutEffect(() => {
        document.getElementById("pm-boot")?.remove();
    }, []);
    return null;
}

/** The waiting page: the platform mark inside a turning ring, and no words. */
export function BootScreen({ fullscreen = true, label = "Loading", className }: ScreenProps) {
    return (
        <div className={`pm-loader${fullscreen ? " pm-loader--page" : " pm-loader--inline"}${
            className ? ` ${className}` : ""}`}
             role="status" aria-live="polite" aria-label={label}>
            <span className="pm-loader__badge">
                <span className="pm-loader__track" aria-hidden="true" />
                <span className="pm-loader__sweep" aria-hidden="true" />
                <img className="pm-loader__logo" src={PROMASTER_MARK} alt="" />
            </span>
        </div>
    );
}

/** The same waiting page with the user's language. */
export function BootLoader({ fullscreen = true, className }: Pick<ScreenProps, "fullscreen" | "className">) {
    const { t } = useTranslation();
    return (
        <BootScreen fullscreen={fullscreen} label={t("app.loading")} className={className} />
    );
}
